module.exports = __webpack_public_path__ + "static/logo-01fa70dff635cb0f10500b03d71b73dd.svg";